export const TRANSLATIONS_PT_CHAT_TASKS_AND_PROFILE = {
  "tasks.process_document_a": "Processar documento A",
  "tasks.extract_entities_a": "Extração de entidades do documento A",
  "tasks.classify_document_b": "Classificar documento B",
  "tasks.classify_b_desc": "Classificação automática do documento B",
  "tasks.index_document_c": "Indexar documento C",
  "tasks.index_c_desc": "Indexação do documento C para busca",
  "tasks.summarize_document_d": "Resumir documento D",
  "tasks.summarize_d_desc": "Geração automática de resumo",
  "chat.title": "Assistente de Documentos",
  "chat.grounding.evidence.aria": "Estado da evidência",
  "chat.grounding.evidence.grounded": "Apoiado em documentos",
  "chat.grounding.evidence.partially_grounded": "Apoio parcial",
  "chat.grounding.evidence.no_evidence": "Sem evidência documental",
  "chat.grounding.evidence.validation_failed": "Não foi possível validar a evidência",
  "chat.grounding.evidence.retrieval_failed": "Não foi possível recuperar evidência",
  "chat.grounding.evidence.unknown": "Evidência indeterminada",
  // Avisos (P2-1): `retrieval_failed` NÃO é `no_evidence` — nada foi recuperado por causa
  // de uma falha, o que não é o mesmo que não haver nada. Textos distintos de propósito.
  "chat.grounding.evidence.warning.partially_grounded": "Esta resposta apoia-se apenas em parte da evidência disponível e pode estar incompleta. Revise as fontes antes de usar valores ou datas.",
  "chat.grounding.evidence.warning.no_evidence": "Nenhum documento foi recuperado para esta pergunta: esta resposta não é respaldada pelos seus documentos.",
  "chat.grounding.evidence.warning.validation_failed": "Não foi possível validar que esta resposta corresponde aos documentos recuperados. Revise as fontes antes de usar valores ou datas.",
  "chat.grounding.evidence.warning.retrieval_failed": "Não foi possível recuperar a evidência devido a um erro do sistema. Esta resposta não é respaldada pelos seus documentos; tente novamente.",
  "chat.generation.proposal.generateHere": "Gerar aqui",
  "chat.generation.enqueued": "Seu resumo está sendo processado. Clique aqui para ver o andamento.",
  "chat.generation.viewProgress": "Ver em Documentos Gerados",
  "chat.generation.forbidden": "Seu plano não permite gerar resumos ou a cota foi atingida.",
  "chat.generation.error": "Não foi possível enfileirar a geração.",
  "chat.generation.proposal.button": "Gerar resumo executivo",
  "chat.generation.proposal.fallback": "Posso gerar um resumo executivo dos seus documentos. Gero?",
  "chat.generation.generateSummary": "Gerar Resumo",
  "chat.generation.defaultHint": "Gere um resumo executivo dos meus documentos",
  "chat.plus.menuLabel": "Ações",
  "chat.plus.modeSection": "Tipo de busca",
  "chat.generation.candidatesQuestion": "Encontrei estes documentos para o seu resumo. Gero o resumo com eles?",
  "chat.generation.proposal.confirm": "Sim, gerar resumo",
  "chat.generation.proposal.adjust": "Ajustar no assistente",
  "chat.generation.unnamedDoc": "Documento",
  "chat.generation.armedPlaceholder": "Descreva o resumo que deseja gerar…",
  "chat.generation.armedCancel": "Cancelar Gerar Resumo",
  "chat.placeholder": "Digite sua mensagem...",
  "chat.send": "Enviar",
  "chat.sources": "Fontes",
  // `score` é a similaridade de cosseno do retrieval, não uma medida de confiança.
  "chat.relevance": "Relevância",
  "chat.error.unsupportedQuestion": "Desculpe, não entendi o tipo de pergunta. Você poderia me dar mais contexto ou detalhes?",
  "chat.error.unexpected": "Ocorreu um erro inesperado.",
  "chat.error.unknownResponse": "Resposta desconhecida do sistema.",
  "chat.download": "Baixar",
  "chat.feedback": "Esta resposta foi útil?",
  "chat.yes": "Sim",
  "chat.no": "Não",
  "chat.feedback_comment": "Adicione um comentário (opcional)",
  "chat.feedback_thanks": "Obrigado pelo seu feedback!",
  "chat.clear": "Limpar chat",
  "chat.show_details": "Ver detalhes",
  "chat.hide_details": "Ocultar detalhes",
  "chat.selected_source": "Fonte selecionada",
  "chat.location": "Localização",
  "chat.chunk": "Trecho",
  "chat.typing": "Digitando...",
  "chat.recover": "Recuperar conversa",
  "chat.new_session": "Nova sessão",
  "chat.close": "Fechar chat",
  "chat.message_change_name_success": "Nome do chat atualizado corretamente",
  "chat.search_type": "Tipo de busca",
  "chat.search_type.light": "Leve",
  "chat.search_type.default": "Padrão",
  "chat.search_type.medium": "Médio",
  "chat.search_type.strong": "Forte",
  "chat.input_placeholder": "Pergunte qualquer coisa",
  "chat.edit_message": "Editar mensagem",
  "chat.edit": "Editar",
  "chat.copy_message": "Copiar mensagem",
  "chat.like_message": "Curtir",
  "chat.dislike_message": "Não curtir",
  "chat.deselect_message": "Desmarcar mensagem",
  "chat.copied": "Copiado",
  "chat.download_document": "Baixar documento",
  "chat.documents": "Documentos",
  "chat.document": "Documento",
  "chat.double_click_hint": "Clique duplo para ver as fontes",
  "chat.click_to_read_source": "Clique para ler esta fonte",
  "chat.fragment_text": "Trecho citado",
  "chat.star_rating_title": "{{count}} estrelas",
  "chat.downloaded": "Baixado",
  "chat.close_detail": "Fechar detalhe",
  "chat.session_name_empty_error": "O nome não pode estar vazio.",
  "chat.session_untitled": "Sessão sem nome",
  "chat.rename": "Renomear",
  "chat.save": "Salvar",
  "chat.cancel": "Cancelar",
  "chat.no_previous_sessions": "Sem sessões anteriores.",
  "tasks.pending": "Tarefas pendentes",
  "tasks.processed": "Tarefas processadas",
  "tasks.created": "Tarefas criadas",
  "tasks.processed_at": "Processado em",
  "tasks.loading": "Carregando tarefas...",
  "tasks.status": "Status",
  "tasks.step": "Etapa",
  "tasks.description": "Descrição",
  "tasks.created_by": "Criado por",
  "tasks.no_processed": "Nenhuma tarefa processada ainda.",
  "tasks.filters": "Filtros",
  "tasks.filter_by_id": "Filtrar por ID da tarefa",
  "tasks.filter_by_date": "Filtrar por data",
  "tasks.clear_filters": "Limpar filtros",
  "tasks.no_pending": "Nenhuma tarefa pendente.",
  "profile.name": "Nome",
  "profile.email": "E-mail",
  "profile.company": "Empresa",
  "profile.role": "Função",
  "profile.title": "Perfil",
  "profile.section_personal": "Informações pessoais",
  "profile.section_organization": "Organização",
  "profile.country": "País",
  "profile.country_select": "Selecione um país",
  "profile.section_preferences": "Preferências",
  "profile.email_managed": "E-mail gerenciado pelo sistema",
  "profile.role_managed": "Função gerenciada pelo sistema",
  "profile.job_title": "Cargo",
  "profile.organization_type": "Tipo de organização",
  "profile.organization_size": "Tamanho da organização",
  "profile.loading": "Carregando perfil...",
  "profile.loading_data": "Carregando dados do perfil...",
  "profile.save": "Salvar Perfil",
  "profile.save_success": "Perfil salvo com sucesso.",
  "chat.inputmode_question": "Obter informações do documento",
  "chat.inputmode_csv": "Consulta CSV",
  "chat.inputmode_db": "Consulta ao Banco de Dados",
  "chat.inputmode_count_documents": "Contagem de documentos",
  "chat.no_sessions": "Sem sessões",
  "chat.tools": "Ferramentas",
  "chat.expertRole.label": "Responder como…",
  "chat.expertRole.placeholder": "Sem papel",
  "chat.expertRole.clear": "Remover especialista",
  "chat.expertRole.applied": "Respondido como",
  "chat.expertRole.notEntitled": "Seu plano não inclui papéis especializados",
  "chat.expertRole.degraded": "O papel selecionado não foi aplicado a esta resposta.",
  "chat.expertRole.messageBadge": "Consulta com especialista",
  "profile.change_photo": "Alterar foto",
  "profile.name_required": "O nome é obrigatório.",
  "profile.load_error": "Erro ao carregar o perfil.",
  "profile.photo_upload_error": "Erro ao enviar a foto.",
  "profile.save_error": "Erro ao salvar o perfil.",
  "tasks.filter_by_status": "Filtrar por status",
  "tasks.filter_by_user": "Filtrar por usuário",
  "tasks.filter_by_description": "Filtrar por descrição",
};
